<template>
  <v-main
    class="policy-overview-content pt-0"
    role="presentation"
    :class="$vuetify?.display?.lgAndUp ? 'removeLeftMargin' : ''"
  >
    <AlertsComponent context="app" v-if="showAlertsBasedOnEnv" />
    <v-container>
      <v-card
        v-if="relatedToUnsupportedBrowser"
        class="mx-auto mb-xs-12"
        :class="$vuetify.display.xs ? 'overall-div-card-smaller' : 'overall-div-card-larger'"
      >
        <v-row>
          <v-col class="text-center" id="unsupported_browser_title">
            <h1 class="font-weight-regular">
              {{ $t('L_unsupported_browser_title') }}
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col id="unsupported_browser_prompt" class="text-center">
            <span class="text-body-1 text-h6 font-weight-regular">
              {{ $t('L_unsupported_browser_prompt') }}
            </span>
          </v-col>
        </v-row>
        <v-row class="pt-4 mb-xs-12">
          <v-col cols="4" class="text-center" pr-2>
            <v-img
              cover
              alt="Primerica"
              class="mx-auto mb-2 maxHeightWidth text-h6 font-weight-regular"
              src="@/assets/browser-chrome.png"
            />
            <p>
              <a
                class="font-weight-regular"
                :class="
                  $vuetify?.display?.mdAndUp
                    ? 'largerFontSizeBrowserName'
                    : 'smallerFontSizeBrowserName'
                "
                href="https://www.google.com/chrome/"
                target="_blank"
              >
                {{ $t('L_unsupported_browser_google_chrome') }}
              </a>
            </p>
          </v-col>
          <v-col cols="4" class="text-center" pr-2>
            <div class="text-h6 font-weight-regular text-center">
              <v-img
                cover
                alt="Primerica"
                class="mx-auto mb-2 maxHeightWidth"
                src="@/assets/browser-edge.png"
              />
              <p>
                <a
                  class="font-weight-regular"
                  :class="
                    $vuetify.display.mdAndUp
                      ? 'largerFontSizeBrowserName'
                      : 'smallerFontSizeBrowserName'
                  "
                  href="https://www.microsoft.com/en-us/edge"
                  target="_blank"
                  >{{ $t('L_unsupported_browser_microsoft_edge') }}</a
                >
              </p>
            </div>
          </v-col>
          <v-col cols="4" class="text-center" pr-2>
            <div class="text-h6 font-weight-regular text-center">
              <v-img
                cover
                alt="Primerica"
                class="mx-auto mb-2 maxHeightWidth"
                src="@/assets/browser-safari.png"
              />
              <p>
                <a
                  class="font-weight-regular"
                  :class="
                    $vuetify.display.mdAndUp
                      ? 'largerFontSizeBrowserName'
                      : 'smallerFontSizeBrowserName'
                  "
                  href="https://www.apple.com/safari/"
                  target="_blank"
                >
                  {{ $t('L_unsupported_browser_apple_safari') }}
                </a>
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-row
        v-if="!relatedToUnsupportedBrowser"
        fill-height
        class="text-white"
        :class="{ 'mb-4': $vuetify.display.mdAndUp }"
      >
        <v-col cols="12" class="view-policy-section policy-number">
          {{ $t('L_init_error_msg') }}
        </v-col>
        <v-col cols="12 mt-4">
          <a
            id="login-link"
            class="text-white"
            @click.prevent="goToLogin"
            href="javascript:void(0)"
          >
            {{ $t('L_go_login') }}
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script lang="ts">
import { useGlobalStore } from '@/stores/global/global.store';
import { mapActions } from 'pinia';
import { defineComponent } from 'vue';
import AlertsComponent from '@/components/AlertsComponent.vue';
import { Environment } from '@/shared/models/appConfig.model';
import { $t } from '@/i18n/i18n.ts';

export default defineComponent({
  name: 'ErrorLayout',
  components: {
    AlertsComponent,
  },
  data: () => ({
    relatedToUnsupportedBrowser: false,
  }),
  computed: {
    showAlertsBasedOnEnv() {
      return window.appConfig.env !== Environment.PROD;
    },
  },
  methods: {
    $t,
    ...mapActions(useGlobalStore, ['goToLogin']),
  },
  mounted() {
    const ua = navigator.userAgent;
    // const isChrome = ua.indexOf('Chrome/') !== -1 && ua.indexOf('Chromium/') === -1;
    // const isSafari = ua.indexOf('Safari/') !== -1 && ua.indexOf('Chrome/') === -1 && ua.indexOf('Chromium/') === -1;
    // const isEdge = ua.indexOf('Edg') !== -1;
    // const isFirefox = ua.indexOf('Firefox/xyz') !== -1;
    const isInternetExplorer =
      ua.includes('Trident/') && (ua.includes('rv:') || ua.includes('MSIE'));
    const exclusionList = isInternetExplorer;
    if (exclusionList) {
      this.relatedToUnsupportedBrowser = false;
      // this.relatedToUnsupportedBrowser = true;
    }
  },
});
</script>

<style lang="scss" scoped>
.overall-div-card-larger {
  position: relative !important;
  width: 100%;
  max-width: 1120px;
  padding: 40px;
}
.overall-div-card-smaller {
  position: relative !important;
  width: 100%;
  max-width: 1120px;
  padding: 8px;
}
#supportedBrowsers {
  background-image: linear-gradient(#063562, #607c97);
  height: 100%;
  position: absolute;
  margin: auto;
}
.supported-browsers-content {
  max-width: 100% !important;
  @media only screen and (min-width: 760px) {
    max-width: 75% !important;
  }
}
#unsupported_browser_title {
  @media only screen and (max-width: 760px) {
    font-size: 32px !important;
  }
}
#unsupported_browser_prompt {
  @media only screen and (max-width: 760px) {
    font-size: 16px !important;
  }
}
#supportedBrowsers p {
  color: #333 !important;
}
#supportedBrowsers a.text-decoration-none {
  text-decoration: none !important;
}
a.underline-link {
  text-decoration: underline !important;
}
.pad-bottom {
  padding-bottom: 100px;
}
.maxHeightWidth {
  max-height: 200px;
  max-width: 200px;
}
.removeLeftMargin {
  margin-left: -119px;
}
.largerFontSizeBrowserName {
  font-size: 20px;
}
.smallerFontSizeBrowserName {
  font-size: 12px;
}
</style>
